import { AuthProvider } from 'react-admin';
import { authService } from '@/services/authService';

export const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    console.log('🔐 Login iniciado');
    try {
      const data = await authService.login({ email: username, password });
      console.log('✅ Login exitoso, token recibido:', !!data.accessToken);
      // ✅ No necesitamos llamar setTokens aquí porque login() ya lo hace internamente
      return Promise.resolve();
    } catch (error: any) {
      console.log('❌ Login fallido:', error?.message);
      return Promise.reject(error?.message || 'Error de login');
    }
  },
  logout: () => {
    console.log('🚪 Logout llamado');
    authService.logout();
    window.location.href = '/login';
    return Promise.resolve();
  },
  checkError: error => {
    const status = error.status;
    console.log('🔍 checkError called with status:', status);

    if (status === 401 || status === 403) {
      // Verificar si ya estamos en la página de login para evitar ciclos
      if (window.location.pathname !== '/login') {
        console.log('❌ checkError: Token inválido, cerrando sesión');
        authService.logout();
        window.location.replace('/login');
      }
      return Promise.reject();
    }
    return Promise.resolve();
  },
  checkAuth: () => {
    console.log('🔄 checkAuth llamado');
    const token = authService.getAccessToken();
    const isExpired = authService.isTokenExpired();

    console.log('📊 Estado del token:', {
      tokenExists: !!token,
      tokenValue: token ? `${token.substring(0, 10)}...` : 'none',
      isExpired: isExpired,
      expiresAt: localStorage.getItem('expiresAt'),
    });

    if (isExpired || !token) {
      console.log('🚨 checkAuth: Redirigiendo a login');
      authService.logout();
      return Promise.reject();
    }

    console.log('✅ checkAuth: Autenticación válida');
    return Promise.resolve();
  },
  getPermissions: () => {
    const roles = localStorage.getItem('userRoles');
    return Promise.resolve(roles ? JSON.parse(roles) : []);
  },
  getIdentity: async () => {
    console.log('👤 getIdentity llamado');
    try {
      const response = await authService.getLoggedUser();

      if (response.success && response.user) {
        const user = {
          id: response.user.id,
          fullName: response.user.fullName,
          userName: response.user.userName,
          email: response.user.email,
          phoneNumber: response.user.phoneNumber,
          avatar: undefined, // Opcional: puedes agregar avatar si está disponible
        };

        console.log('✅ Usuario obtenido:', user);
        return Promise.resolve(user);
      }

      throw new Error('No se pudo obtener la información del usuario');
    } catch (error) {
      console.error('❌ Error en getIdentity:', error);
      // En caso de error, devolver un usuario por defecto para evitar crashes
      return Promise.resolve({
        id: 'unknown',
        fullName: 'Usuario',
      });
    }
  },
};
